// extracted by mini-css-extract-plugin
export default {"button":"Co-z","reviewSort":"Do-z"};